export default __webpack_public_path__ + "static/media/709.8e80c2cc.gif";